import React from "react";
import PropTypes from "prop-types";
import styles from "./styles/graphicset-preview.css.js";
import withStyles from "components/with-styles";
import { AssetDisplay } from "components/thumbnail";

const GraphicSetPreview = ({ graphicSet, classes }) => {
  const layoutsToRender = graphicSet.layouts || [];
  const assets = layoutsToRender.slice(0, 3).map(layout => layout.asset);

  return assets.map(asset => {
    return (
      asset && (
        <div className={classes.imageContainer} key={asset.id}>
          <AssetDisplay preview asset={asset} width={50} />
        </div>
      )
    );
  });
};

GraphicSetPreview.propTypes = {
  /**
   * Indica si la query se debouncea.
   **/
  debounce: PropTypes.bool,
};

export default withStyles(styles)(GraphicSetPreview);
